import axios from "axios";
import * as Preferences from "./Preferences";

export const SubmitComboTicket = (ticketInfo, ticketPairs, callback) => {
  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.TICKET_HANDLER_SUBMIT_COMBO_TICKET_SUFFIX;

  //console.log("CALLING SUBMITTICKET FROM: " + svcUrl);
  //console.log("CALLBACK IS: " + callback);

  //zovi axios
  axios
    .post(svcUrl, {
      ticketInfo: ticketInfo,
      ticketPairs: ticketPairs
    })
    .then(response => {
      console.log("Received response! ", response);
      callback(response.data);
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      callback(null);
    });
};

export const SubmitSystemTicket = (
  ticketInfo,
  ticketPairs,
  systems,
  callback
) => {
  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.TICKET_HANDLER_SUBMIT_SYSTEM_TICKET_SUFFIX;

  //console.log("CALLING SUBMITTICKET FROM: " + svcUrl);
  //console.log("CALLBACK IS: " + callback);

  //zovi axios
  axios
    .post(svcUrl, {
      ticketInfo: ticketInfo,
      ticketPairs: ticketPairs,
      systems: systems
    })
    .then(response => {
      console.log("Received response! ", response);
      callback(response.data);
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      callback(null);
    });
};

export const SelectTicket = (ticketNumber, ticketCode, callback) => {
  console.log("IN SELECT REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.TICKET_HANDLER_SELECT_TICKET_SUFFIX;

  //console.log("CALLING SelectTicket FROM: " + svcUrl);
  //console.log("CALLBACK IS: " + callback);

  //zovi axios
  axios
    .post(svcUrl, {
      ticketNumber: ticketNumber,
      securityCode: ticketCode
    })
    .then(response => {
      console.log("Received response! ", response);
      callback(response.data);
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      callback(null);
    });
};

export const SelectTicketPairs = (ticketID, callback) => {
  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.TICKET_HANDLER_SELECT_TICKET_PAIRS_SUFFIX;

  //console.log("CALLING SelectTicketPairs FROM: " + svcUrl);
  //console.log("CALLBACK IS: " + callback);

  //zovi axios
  axios
    .post(svcUrl, {
      ticketID: ticketID
    })
    .then(response => {
      console.log("Received response! ", response);
      callback(response.data);
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      callback(null);
    });
};

export const MakeTicketWinning = (ticketNumber, callback) => {
  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.TICKET_HANDLER_MAKE_TICKET_WINNING_SUFFIX;

  //console.log("CALLING SelectTicketPairs FROM: " + svcUrl);
  //console.log("CALLBACK IS: " + callback);

  //zovi axios
  axios
    .post(svcUrl, {
      ticketNumber: ticketNumber
    })
    .then(response => {
      console.log("Received response! ", response);

      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);

      if (callback) {
        callback(null);
      }
    });
};

export const MakeTicketLosing = (ticketNumber, callback) => {
  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.TICKET_HANDLER_MAKE_TICKET_LOSING_SUFFIX;

  //console.log("CALLING SelectTicketPairs FROM: " + svcUrl);
  //console.log("CALLBACK IS: " + callback);

  //zovi axios
  axios
    .post(svcUrl, {
      ticketNumber: ticketNumber
    })
    .then(response => {
      console.log("Received response! ", response);

      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);

      if (callback) {
        callback(null);
      }
    });
};

export const AuthorizeTicket = (ticketID, callback) => {
  let svcUrl =
    Preferences.LOCALHOST_BASE_URL + Preferences.TICKET_HANDLER_AUTHORIZE;

  //console.log("CALLING SelectTicketPairs FROM: " + svcUrl);
  //console.log("CALLBACK IS: " + callback);

  //zovi axios
  axios
    .post(svcUrl, {
      ticketID: ticketID
    })
    .then(response => {
      console.log("Received response! ", response);

      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);

      if (callback) {
        callback(null);
      }
    });
};

export const PayoutToUserSession = (
  terminalGUID,
  receiptNumber,
  securityCode,
  callback
) => {
  console.log("IN SELECT REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.TICKET_HANDLER_PAYOUT_TO_USER_SESSION;

  //zovi axios
  axios
    .post(svcUrl, {
      terminalGUID: terminalGUID,
      ticketNumber: receiptNumber,
      securityCode: securityCode
    })
    .then(response => {
      console.log("Received response! ", response);
      callback(response.data);
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      callback(null);
    });
};



// WEBPACK FOOTER //
// ./src/Communication/TicketServicesHandler.js